import React from "react";
import { Input, Form, Row, Col, message, Radio, Space } from 'antd';
import { getLangList } from '@/lib/i18n';
import ResponsiveTable from '@/components/responsiveTable';
import AttendanceConfig from "@/config/attendance";
import { convertToTimestamp, startTimeToday, endTimeToday, convertTimestampToFormat, dateTimeFormat } from "@/lib/dateTime";
import { hasPermission } from "@/lib/permissionUtil";

const { getSignInfo, signIn } = AttendanceConfig;

interface state {
  signArray: any,
}

class QRCode extends React.Component<{}, state> {
  state = {
    signArray: [],
  };
  attendanceT: any = getLangList("attendance");
  errorT: any = getLangList("error");
  formRef: any = React.createRef();
  inputRef: any = React.createRef();

  componentDidMount() {
    hasPermission('ATTENDANCE_EDIT') && this.inputRef.current.focus();
    this.getSignInfo();
  }

  columns = [
    {
      title: this.attendanceT.TIME,
      dataIndex: "signTime",
      render: (text: any) => convertTimestampToFormat(text, dateTimeFormat),
    },
    { title: this.attendanceT.NAME_CN, dataIndex: "nameCn", render: (text: any) => `${text[0]}◯${text.slice(2)}` },
    { title: this.attendanceT.NAME_EN, dataIndex: "nameEn" },
  ];

  getSignInfo = () => {
    const params = {
      startTime: convertToTimestamp(startTimeToday),
      endTime: convertToTimestamp(endTimeToday),
    };

    getSignInfo(params).then((res: any) => {
      const signArray = res?.value ?? {};
      this.setState({ signArray });
    });
  }

  signIn = () => {
    const { signValue, signBy } = this.formRef.current.getFieldsValue();
    const value = signValue?.trim();
    const params = { [signBy]: value };

    if (!value) {
      return message.error(this.errorT.PLEASE_ENTER(`${this.attendanceT.ACCESS_CARD_NUMBER}、${this.attendanceT.STUDENT_ID_PLACEHOLDER}`));
    }

    signIn(params).then((res: any) => {
      if (!res.success) {
        return message.error(this.errorT.failed);
      }
      message.success(this.errorT.success);
      this.formRef.current.setFieldsValue({ signValue: '' });
      this.getSignInfo();
    });
  }

  render() {
    const { signArray }: any = this.state;

    return (
      <>
        <Row justify="center">
          {hasPermission('ATTENDANCE_EDIT') &&
            <Col>
              <Form
                ref={this.formRef}
                initialValues={{
                  signBy: 'accessCardNumber',
                }}
              >
                <Space>
                  <Form.Item name="signBy" rules={[{ required: true }]}>
                    <Radio.Group onChange={() => this.inputRef.current.focus()}>
                      <Space>
                        <Radio value='accessCardNumber'>{this.attendanceT.ACCESS_CARD_NUMBER}</Radio>
                        <Radio value='username'>{this.attendanceT.ACCOUNT}</Radio>
                      </Space>
                    </Radio.Group>
                  </Form.Item>

                  <Form.Item name="signValue">
                    <Input
                      onPressEnter={this.signIn}
                      ref={this.inputRef}
                      placeholder={`${this.attendanceT.ACCESS_CARD_NUMBER}、${this.attendanceT.STUDENT_ID_PLACEHOLDER}`}
                      style={{ width: '250px' }}
                    />
                  </Form.Item>
                </Space>
              </Form>
            </Col>
          }
        </Row>

        <Row>
          <Col span={24}>
            <ResponsiveTable
              {...this.props}
              dataSource={signArray}
              columns={this.columns}
              displayScrollY={false}
            />
          </Col>
        </Row>
      </>
    );
  }
}

export default QRCode;